import * as React from 'react'
import { useState } from 'react'
import { Box } from '@mui/material'
import { Container } from '@mui/material'
import { ToggleButton } from '@mui/material'
import { ToggleButtonGroup } from '@mui/material'
import { HostServiceDetailPriceListChart } from './HostServiceDetailPriceListChart'
import { HostServiceDetailPriceListTable } from './HostServiceDetailPriceListTable'
import styles from './HostServiceDetailPrices.module.css'

export interface HostServiceDetailPricesProps {
    hostServiceId: number
    monitorId?: number
}

export const HostServiceDetailPrices = ({ hostServiceId, monitorId }: HostServiceDetailPricesProps): JSX.Element => {
    const [viewMode, setViewMode] = useState<string>('table')

    const toggleSelectorRender = () => {
        return (
            <>
                <ToggleButtonGroup
                    color="primary"
                    value={viewMode}
                    exclusive
                    onChange={viewModeChanged}
                    aria-label="view"
                >
                    <ToggleButton value="table">Table</ToggleButton>
                    <ToggleButton value="chart">Chart</ToggleButton>
                </ToggleButtonGroup>
            </>
        )
    }

    const parametersViewRender = () => {
        if (viewMode === 'table') {
            return (
                <HostServiceDetailPriceListTable
                    hostServiceId={hostServiceId}
                    marketSpyId={monitorId}
                />
            )
        }

        if (viewMode === 'chart') {
            return (
                <>
                    <HostServiceDetailPriceListChart
                        hostServiceId={hostServiceId}
                        marketSpyId={monitorId}
                    ></HostServiceDetailPriceListChart>
                </>
            )
        }

        return (
            <>

            </>
        )
    }

    const viewModeChanged = (
        event: React.MouseEvent<HTMLElement>,
        newViewMode: string,
    ) => {
        setViewMode(newViewMode);
    }

    return (
        <>
            <Container>
                <div 
                    className={styles.HostServiceDetailPrices__Header}
                >
                    <h2>Prices</h2>
                    <Box p={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {
                            toggleSelectorRender()
                        }
                    </Box>
                </div>
                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                    {
                        parametersViewRender()
                    }              
                </Box>
            </Container>
        </>
    )
}
